import { LinearProgress, FormHelperText, FormControl, Link, Grid, SelectProps, InputLabel, Select, MenuItem, TextField, SelectChangeEvent, Dialog, DialogContent, DialogTitle, DialogActions, IconButton, Paper, Typography, Button, Autocomplete } from "@mui/material";
import { DataGridPro, GridColDef, GridFooterContainer, GridPagination } from "@mui/x-data-grid-pro";
import { Formik, Form } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import useAuth from "../../context/AuthProvider";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import "react-datepicker/dist/react-datepicker.css";
import { FMTextField } from "../Elements/input";
import CircularProgress from '@mui/material/CircularProgress';
import { FileRejection, useDropzone } from 'react-dropzone';
import Tooltip from '@mui/material/Tooltip';
import Swal from "sweetalert2";
import { CustomerPolicyDocument, CustomerPolicyTaxAndFees, UploadedDocumentType } from "../../models/TaxTransactionReportModel";
import { CustomerPolicyDetailsModel } from "../../models/CustomerPolicyDetailsModel";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import * as Yup from 'yup';
import { compactString, dateOnlyStringToUtcIsoString, formatUtcToLocal, mstDateStringToUtcIsoString, parseAnyDateToDateOnly, pickerDateToUtcIsoStringForMst } from "../../helper/utils";
import { isValid } from "../Elements/PolicyStatuses";
import { isDateGreaterThanToday } from "./CustomFunctions";
import { apiClient } from "../../helper/api";
import useAppDialog from "../../hooks/useAppDialog";
import { DialogResponse, DialogResult } from "../Dialog/dialogTypes";
import { Box } from "@mui/system";
import { AppFlags } from "../../helper/config";
import { AppRoutes } from "../../helper/appRoutes";
import { useExtractionStates } from "../../helper/filingReviewStates";
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { StatesModel } from "../../Pages/RequestSignature";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

const sectionTitleSx = { color: 'text.secondary', fontWeight: 600, letterSpacing: '0.08em', display: 'block', mb: 1 };
const paperSectionSx = { p: 2, borderRadius: 2, borderColor: 'divider', backgroundColor: 'grey.50' };
const textFieldSx = {
    '& .MuiOutlinedInput-notchedOutline': { border: '2px solid #e2e8f0 !important', borderRadius: '8px !important' },
    '& .MuiInputBase-input': { padding: '3.5px 14px !important' },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.87) !important' },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2 !important' },
};
const selectFieldSx = {
    width: '100%',
    mt: '3px',
    '& .MuiSelect-select': { padding: '14.5px 16px' },
    '& .MuiOutlinedInput-notchedOutline': { border: '2px solid #e2e8f0 !important', borderRadius: '8px' },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.87) !important' },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2 !important' },
};

export interface LObList {
    id: number;
    businessCode: string;
    coverageName: string;
    stateId: number;
}

export interface ReqDocuments {
    documentName?: string,
    documentTypeId?: number
    isRequired?: boolean
}

export const AddEditCustomerPolicyDetails = () => {
    const [loading, setloading] = useState(true);
    const { user } = useAuth();
    const token = user?.token;
    const { isFilingReviewSupportedState } = useExtractionStates();
    const params = useParams();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const isFileMuleUser = user?.userRoles.split(",").includes("Super Admin")
    const rolesTrimmed = user?.userRoles.split(",").map((r) => r.trim()) ?? [];
    const policyReadOnlyFromCompleted =
        searchParams.get("fromQueue") === "completed" &&
        (rolesTrimmed.includes("MISC Filer") || rolesTrimmed.includes("MISC State Reporter")) &&
        !rolesTrimmed.includes("Super Admin");

    const initCustomerPolicyDetails: CustomerPolicyDetailsModel = {}
    const [CustomerPolicyDetails, setCustomerPolicyDetails] = useState(initCustomerPolicyDetails)
    const [selectedTransaction, setselectedTransaction] = useState<string>('')
    const [selectedLOB, setSelectedLOB] = useState<string>('')
    const [partnerId, setPartnerId] = useState<string>("")
    const [PolicyDocument, setPolicyDocument] = React.useState<CustomerPolicyDocument[]>([]);
    const [UploadedDocument, setUploadedDocument] = React.useState<UploadedDocumentType[]>([]);
    const [revertedDocument, setRevertedDocument] = React.useState<UploadedDocumentType[]>([]);
    const [CustTaxAndFees, setCustTaxAndFees] = useState<CustomerPolicyTaxAndFees[]>([]);
    const [deletedTaxAndFeeIds, setDeletedTaxAndFeeIds] = useState<number[]>([]);
    const [taxAndFeeOptions, setTaxAndFeeOptions] = useState([]);
    const [policyNumber, setPolicyNumber] = useState<string>("");
    const [binderFiledDate, setBinderFiledDate] = useState<string>("");
    const [revertDocument, setRevertDocument] = useState<{ documentTypeId: number; customerPolicyDocumentId: number; isRevert: boolean}[]>([]);
    const [selectedStateOption, setSelectedStateOption] = useState<any>(1);
    const initialStates = { stateId: 0, stateName: "" };
    const [data, setData] = useState<any>(null);
    const [States, setStates] = useState([initialStates]);
    const [showDoc, setShowDoc] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [hasExtractionRecord, setHasExtractionRecord] = useState(false);

    const Reqdocuments: ReqDocuments = {
        documentName: "",
        documentTypeId: 0,
        isRequired: false,
    }
  
    const [RequireedDocuments, setRequiredDocuments] = useState([Reqdocuments]);

    let initTaxAndFee: CustomerPolicyTaxAndFees = {
        customerPolicyId: 0,
        amount: "",
        payee: "",
        taxName: "",
        paymentPeriod: ""
    }
    const createTaxAndFeeRow = (): CustomerPolicyTaxAndFees => ({
        ...initTaxAndFee,
        tempId: Date.now() + Math.random()
    });

    /**
     * Raw numeric string for NumericFormat (valueIsNumericString): optional leading '-', digits, optional '.'.
     * Strips $/commas/spaces, maps Unicode minus, and (1,234.56) accounting negatives to -1234.56.
     */
    const normalizeTaxAmountForNumericFormat = (raw: string | number | undefined): string => {
        if (raw == null) return '';
        if (typeof raw === 'number' && Number.isFinite(raw)) return raw === 0 ? '0' : String(raw);
        let str = String(raw).trim().replace(/\u2212/g, '-');
        if (str === '' || str === '-') return str === '-' ? '-' : '';

        let neg = false;
        if (/^\(.*\)$/.test(str)) {
            neg = true;
            str = str.slice(1, -1).trim();
        }
        str = str.replace(/\$/g, '').replace(/,/g, '').replace(/\s/g, '');
        if (str === '') return '';
        if (neg) {
            if (str.startsWith('-')) str = str.slice(1);
            str = '-' + str;
        }
        return str;
    };

    const goBack = () => {
        navigate(AppRoutes.root);
    }
    const getDocTypeName = (docTypeId: number) => {
        const doc = RequireedDocuments.find((d) => d.documentTypeId === docTypeId);
        return doc ? doc.documentName : "";
    }

    // Helper function to display MISC user names as "miscstaff" for client users
    const getDisplayName = (uploadedBy: string, uploadedByRoleId?: number) => {
        if (!user?.userRoles) return uploadedBy || '-';
        
        const roles = user.userRoles.split(",");
        const isClientUser = roles.some(role => 
            ['Customer User', 'Client Admin', 'Client Accounting', 'Client Operations', 'Client Processors'].includes(role.trim())
        );
        
        if (isClientUser) {
            const clientRoleIds = [1, 6, 8, 9, 10, 11];
            return clientRoleIds.includes(uploadedByRoleId || 0) ? uploadedBy || '-' : 'MISC team';
        } else {
            return uploadedBy || '-';
        }
    }
    const fetchData = () => {
        setloading(true);
        setSelectedLOB('');
        setInsuranceId('');
        apiClient(`/PolicyDashBoard/getCustomerPolicyDetails?customerPolicyId=${params.CustomerPolicyId}`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }).then((res) => {
                if (!res) return

                if (res.data != null) {
                    var data = res.data;
                    setData(data)

                    // Effective, Due, Expiry, Invoice: use calendar date only (no MST conversion) so the day does not shift
                    data.policyFilingDueDate = data.policyFilingDueDate !== null && data.policyFilingDueDate !== undefined ? formatUtcToLocal(data.policyFilingDueDate, "MM/DD/YYYY", true) : data.policyFilingDueDate;
                    data.dateFiled = data.dateFiled !== null && data.dateFiled !== undefined && data.dateFiled !== "" ? formatUtcToLocal(data.dateFiled, "MM/DD/YYYY", true) : data.dateFiled;
                    data.dateInvoiceAdded = data.dateInvoiceAdded != null && data.dateInvoiceAdded !== "" ? formatUtcToLocal(data.dateInvoiceAdded, "MM/DD/YYYY", true) : data.dateInvoiceAdded;
                    const rawInv = data.invDate ?? (data as any).InvDate ?? null;
                    const rawPolicyEff = data.policyEffDate ?? (data as any).PolicyEffDate ?? null;
                    const rawPolicyExp = data.policyExpDate ?? (data as any).PolicyExpDate ?? null;
                    const rawFiledBinder = data.filedBinderDate ?? "";
                    // Store date-only (YYYY-MM-DD) so DatePicker shows the same calendar day in all timezones (no TZ shift)
                    data.invDate = parseAnyDateToDateOnly(rawInv) ?? rawInv ?? null;
                    data.policyEffDate = parseAnyDateToDateOnly(rawPolicyEff) ?? rawPolicyEff ?? null;
                    data.policyExpDate = parseAnyDateToDateOnly(rawPolicyExp) ?? rawPolicyExp ?? null;
                    const filedBinderFormatted = formatUtcToLocal(rawFiledBinder, "MM/DD/YYYY", true);
                    data.filedBinderDate = parseAnyDateToDateOnly(rawFiledBinder) ?? (filedBinderFormatted !== "N/A" ? filedBinderFormatted : rawFiledBinder);
                    if (data.filedBinderDate === "" || data.filedBinderDate == null) {
                        data.filedBinderDate = null;
                    }
                    setBinderFiledDate(data.filedBinderDate ?? "");
                    setInsuranceId(data.insuranceCompanyId);
                    setCustomerPolicyDetails(data);
                    setSelectedStateOption(data.stateId);
                    setselectedTransaction(data.transactionId);
                    setPolicyNumber(data.policyNumber);
                    setPartnerId(data.partnersId);
                    setSelectedLOB(data.lobId != null ? String(data.lobId) : '');
                    handleStateChange(data.stateId);

                    setPolicyStatus(data.status);

                }
            }).finally(() => {
                setloading(false);
            });
    }

    const groupedRows = useMemo(() => {
        console.log('groupedRows useMemo running with:', { 
            UploadedDocumentLength: UploadedDocument?.length, 
            RevertedDocumentLength: revertedDocument?.length,
            refreshKey 
        });
        
        const groups = new Map<string, UploadedDocumentType[]>();
        if (UploadedDocument && Array.isArray(UploadedDocument)) {
            UploadedDocument.forEach((doc) => {
                const fileName = Array.isArray((doc as any).documentName) ? ((doc as any).documentName?.[0] || '') : (doc as any).documentName;
                const key = `${doc.blob_Address}::${fileName}`;
                const arr = groups.get(key) || [];
                arr.push(doc);
                groups.set(key, arr);
            });
        }
        const revertGroups = new Map<string, UploadedDocumentType[]>();
        if (revertedDocument && Array.isArray(revertedDocument)) {
            revertedDocument.forEach((doc) => {
                const fileName = Array.isArray((doc as any).documentName) ? ((doc as any).documentName?.[0] || '') : (doc as any).documentName;
                const key = `${doc.blob_Address}::${fileName}`;
                const arr = revertGroups.get(key) || [];
                arr.push(doc);
                revertGroups.set(key, arr);
            });
        }

        const mappedRows = Array.from(groups.values()).map((docs) => {
            const first = docs[0] as any;
            const fileName = Array.isArray(first.documentName) ? (first.documentName?.[0] || '') : first.documentName;
            const docTypeNames = Array.from(new Set(
                docs.map((d) => getDocTypeName(d.documentTypeId) || (d as any).name).filter(Boolean)
            )).join(', ');
            const uploadedAt = first.dateUploadedAt ? formatUtcToLocal(first.dateUploadedAt, 'MM/DD/YYYY HH:mm') : '-';
            // Use the uploadedByFullName field from the API response, fallback to current user if not available
            const uploadedBy = getDisplayName(first.uploadedByFullName || '-', first.uploadedByRoleId);
            // Use the fileSizeKB field from the API response (it's already in KB)
            const sizeText = typeof first.fileSizeKB === 'number' ? `${first.fileSizeKB} KB` : '-';
            const pagesText = typeof first.numberOfPages === 'number' ? first.numberOfPages : '-';
            return { 
                first, 
                fileName, 
                docTypeNames, 
                uploadedAt, 
                uploadedBy, 
                sizeText, 
                pagesText,
                allDocuments: docs, // Store all documents for deletion
                // Add raw date for sorting
                rawUploadDate: first.dateUploadedAt ? new Date(first.dateUploadedAt) : new Date(0),
                isReverted: false
            };
        }).sort((a, b) => b.rawUploadDate.getTime() - a.rawUploadDate.getTime());
        
        const revertedRows = Array.from(revertGroups.values()).map((docs, idx) => {
            const first = docs[0] as any;
            const fileName = Array.isArray(first.documentName) ? (first.documentName?.[0] || '') : first.documentName;
            const docTypeNames = Array.from(new Set(
                docs.map((d) => getDocTypeName(d.documentTypeId) || (d as any).name).filter(Boolean)
            )).join(', ');
            const uploadedAt = first.dateUploadedAt ? formatUtcToLocal(first.dateUploadedAt, 'MM/DD/YYYY HH:mm') : '-';
            // Use the uploadedByFullName field from the API response, fallback to current user if not available
            const uploadedBy = getDisplayName(first.uploadedByFullName || first.uploadedBy || '-', first.uploadedByRoleId);
            // Use the fileSizeKB field from the API response (it's already in KB)
            const sizeText = typeof first.fileSizeKB === 'number' ? `${first.fileSizeKB} KB` : '-';
            const pagesText = typeof first.numberOfPages === 'number' ? first.numberOfPages : '-';
            
            return { 
                first, 
                fileName, 
                docTypeNames, 
                allDocuments: docs, // Store all documents for deletion
                uploadedAt, 
                uploadedBy, 
                sizeText, 
                pagesText,
                isReverted: true,
                rawUploadDate: first.dateUploadedAt ? new Date(first.dateUploadedAt) : new Date(0)
            };
        });

        // Combine all documents and sort by upload date (latest first)
        const allRows = [...mappedRows, ...revertedRows];
        const result = allRows.sort((a, b) => b.rawUploadDate.getTime() - a.rawUploadDate.getTime());
        return result;
    }, [UploadedDocument, revertedDocument, RequireedDocuments, user, refreshKey]);
    const getPolicyDocuments = () => {
        apiClient(`/DiligentSearch/getDiligentSearchDocument?customerPolicyId=${params.CustomerPolicyId}`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }).then((res) => {
                if (!res) return
                setPolicyDocument(res.data);
            })
    }

    const fetchExtractionRecord = () => {
        apiClient(`/AutomaticFiling/getExtractionPolicyByCustomerPolicyId?customerPolicyId=${params.CustomerPolicyId}`, {
            method: "GET",
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            })
        }).then((res) => {
            setHasExtractionRecord(res?.status === true && res?.data != null);
        }).catch(() => {
            setHasExtractionRecord(false);
        });
    };

    const getUploadedDocuments = () => {
        const timestamp = new Date().getTime();
        return apiClient(`/customer/getUploadedDocuments?customerPolicyId=${params.CustomerPolicyId}&_t=${timestamp}`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }).then((res) => {
                if (!res || !res.data || !Array.isArray(res.data)) {
                    console.log('Setting UploadedDocument to empty array');
                    setUploadedDocument([]);
                    return;
                }
                var policyDoc = res.data.filter((item: UploadedDocumentType) => item.documentTypeId === 0);
                setPolicyDocument(policyDoc);
                setUploadedDocument(res.data);
            }).catch((error) => {
                setUploadedDocument([]);
            })
    }

    const getRevertedDocuments = () => {
        const timestamp = new Date().getTime();
        return apiClient(`/customer/getRevertedDocuments?customerPolicyId=${params.CustomerPolicyId}&_t=${timestamp}`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }).then((res) => {
                if (!res || !res.data || !Array.isArray(res.data)) {
                    setRevertedDocument([]);
                    return;
                }
                setRevertedDocument(res.data);
            }).catch((error) => {
                setRevertedDocument([]);
            })
    }
    const fetchCustomerPolicyTaxAndFees = () => {
        apiClient(`/CustomerPolicyTaxesAndFees/getByCustomerPolicyId?customerPolicyId=${params.CustomerPolicyId}`, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        }).then((res) => {
            if (!res) return
            const raw = Array.isArray(res.data) ? res.data : [];
            const list = raw.map((row: CustomerPolicyTaxAndFees) => {
                const withId =
                    row.customerPolicyTaxesAndFeesId != null || row.tempId != null
                        ? row
                        : { ...row, tempId: Date.now() + Math.random() };
                const amt = withId.amount;
                const amountNormalized =
                    amt != null && amt !== ''
                        ? normalizeTaxAmountForNumericFormat(String(amt))
                        : '';
                return { ...withId, amount: amountNormalized };
            });
            setCustTaxAndFees(list.length > 0 ? list : [createTaxAndFeeRow()]);
            setDeletedTaxAndFeeIds([]);
        })
    }
    const fetchTaxAndFeesOptions = () => {
        apiClient(`/TaxesAndFees/GetTaxandFeeNameByStateId?customerPolicyId=${params.CustomerPolicyId}`, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        }).then((responseJson) => {
            if (!responseJson) return
            setTaxAndFeeOptions(responseJson.data);
        })
    }

    useEffect(() => {
        fetchStates();
        fetchData();
        getTransactionType();
        fetchTransactionTypesData();
        fetchCustomerPolicyTaxAndFees();
        fetchTaxAndFeesOptions();
        getPolicyDocuments();
        getUploadedDocuments();
        getRevertedDocuments();
        fetchExtractionRecord();
    }, [])


    const initialInsuranceCompany = { insuranceCompanyId: 0, insuranceCompanyName: "" };
    const [carriers, setCarriers] = useState([initialInsuranceCompany]);
    const initialLOB = { id: 0, businessCode: "" };
    const [LOB, setLOB] = useState([initialLOB]);
    const initialPartners = { partnersId: 0, customerName: "" };
    const [getPartners, setPartners] = useState([initialPartners]);
    const getTransactionType = () => {
        apiClient('/Partners/getPartners',
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }).then((responseJson) => {
                if (responseJson?.data == null) return
                setPartners(responseJson.data)
            })
    }
    interface transactiontypemodel {
        transactionId: number, transactionTypeName: string
    }
    const fetchTransactionTypesData = () => {
        apiClient("/CustomerPolicy/GetTransactionTypeList", {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        }).then((responseJson) => {
            if (!responseJson) return
            // Do something with the response

            const translist: transactiontypemodel[] = responseJson.data.filter((item: transactiontypemodel) => item.transactionTypeName.toLowerCase() !== 'all')
            setTransactionType(translist);
        })
    };

    interface propsDoc {
        open: boolean
        handleDocClose: () => void,
        customerPolicyId: any,
        PolicyDocument: CustomerPolicyDocument[] | undefined
    }
    const handleDocClose = () => {

        setShowDoc(false)
        fetchData();
    };

    const isAdmin = user?.userRoles.split(",").includes("Super Admin")
    const mISCFiler = user?.userRoles.split(",").includes("MISC Filer")
    const MISCStateReporter = user?.userRoles.split(",").includes("MISC State Reporter")
    /** Super Admin–only fields (transaction selection, policy identity, etc.); also full lock when opened read-only from Completed queue. */
    const isAdminOnlyFieldDisabled = !isAdmin || policyReadOnlyFromCompleted
    /** Tax rows, premiums, and related staff edits — disabled when read-only from Completed queue. */
    const staffCanEditTaxAndOperational = (isAdmin || mISCFiler || MISCStateReporter) && !policyReadOnlyFromCompleted
    /** At most one row per available tax type; empty rows count toward the cap so users cannot stack unlimited blank rows. */
    const canAddMoreTaxTypes = useMemo(() => {
        const optionCap = new Set(
            (taxAndFeeOptions ?? [])
                .map((option: any) => compactString(String(option ?? "")) ?? "")
                .filter((name: string) => name.length > 0)
        ).size;
        const rowCount = (CustTaxAndFees ?? []).length;
        // Options not loaded or empty list — avoid unbounded rows if the API fails
        if (optionCap === 0) {
            return rowCount < 20;
        }
        return rowCount < optionCap;
    }, [taxAndFeeOptions, CustTaxAndFees]);
    const isTaxRowEmpty = (row?: CustomerPolicyTaxAndFees) => {
        return (row?.taxName ?? '').trim() === '' &&
            (row?.payee ?? '').trim() === '' &&
            (row?.amount ?? '').trim() === '' &&
            (row?.paymentPeriod ?? '').trim() === '';
    };
    const getTaxRowStableKey = (row: CustomerPolicyTaxAndFees, index: number) =>
        String(row.customerPolicyTaxesAndFeesId ?? row.tempId ?? `idx-${index}`);
    const getAvailableTaxTypeOptions = (rowIndex: number) => {
        const selectedInOtherRows = new Set(
            (CustTaxAndFees ?? [])
                .filter((_, idx) => idx !== rowIndex)
                .map((row) => compactString(row.taxName ?? "") ?? "")
                .filter((name) => name.length > 0)
        );
        return (taxAndFeeOptions ?? []).filter((option: any) => {
            const normalized = compactString(String(option ?? "")) ?? "";
            if (normalized.length === 0) return false;
            return !selectedInOtherRows.has(normalized);
        });
    };
    /** Ensures the row's current tax name appears in the menu (legacy DB value, duplicates, or list drift). */
    const getTaxTypeSelectOptionsForRow = (rowIndex: number) => {
        const base = getAvailableTaxTypeOptions(rowIndex);
        const current = (CustTaxAndFees ?? [])[rowIndex]?.taxName ?? "";
        const nCur = compactString(current) ?? "";
        if (nCur.length === 0) return base;
        const hasCurrent = base.some(
            (opt: any) => (compactString(String(opt ?? "")) ?? "") === nCur
        );
        if (hasCurrent) return base;
        return [current, ...base];
    };
    // Helper function to determine if user can delete documents (admin or client users)
    const canDeleteDocuments = () => {
        if (!user?.userRoles) return false;
        const roles = user.userRoles.split(",");
        return roles.some(role => 
            ['Super Admin', 'Client Admin', 'Customer User', 'Client Accounting', 'Client Operations', 'Client Processors'].includes(role.trim())
        );
    };

    const isPolicyTBD = compactString(policyNumber) === compactString("TBD") || compactString(policyNumber) === compactString("TBA")
    const isPolicyNumberDisabled = policyReadOnlyFromCompleted || !(isAdmin || isPolicyTBD)

    const [TransactionType, setTransactionType] = useState<transactiontypemodel[]>();
    const ShowAllDocument: React.FC<propsDoc> = ({ open, handleDocClose, customerPolicyId, PolicyDocument }) => {

        const { user } = useAuth();
        const token = user?.token;

        useEffect(() => {

        }, [])
        return (

            <Dialog open={open} onClose={handleDocClose} fullWidth maxWidth={'md'}>
                {loading && <LinearProgress style={{ margin: 2 }} />}
                <div > <DialogTitle className='card-title'>All Document</DialogTitle></div>
                <div className="">
                    <React.Fragment>
                        <DialogContent>
                            {PolicyDocument && PolicyDocument?.length > 0 ?
                                <table className="table">
                                    <tbody>

                                        {PolicyDocument?.map((value, key) =>
                                            <Grid gridRow={2} container spacing={2} key={key}>
                                                <tr key={key}>
                                                    <td>
                                                        <div style={{ maxWidth: '920px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                            <Grid>

                                                                <Link href={value.blob_Address} sx={{ textDecoration: "none " }} target="_blank">
                                                                    <span style={{ marginRight: "8px" }}>{value.documentName.split("_").slice(1).join("_")}</span>
                                                                    <svg width="20" height="20" viewBox="0 0 22 22" fill="none" className="" xmlns="http://www.w3.org/2000/svg" ><path d="M19.25 13.75V17.4167C19.25 17.9029 19.0568 18.3692 18.713 18.713C18.3692 19.0568 17.9029 19.25 17.4167 19.25H4.58333C4.0971 19.25 3.63079 19.0568 3.28697 18.713C2.94315 18.3692 2.75 17.9029 2.75 17.4167V13.75M6.41667 9.16667L11 13.75M11 13.75L15.5833 9.16667M11 13.75V2.75" stroke="#02A4E3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path></svg>

                                                                </Link>
                                                            </Grid>

                                                        </div>
                                                    </td>
                                                </tr>
                                            </Grid>
                                        )}
                                    </tbody>
                                </table>
                                : <span>No supportive document found for this transaction.</span>}

                        </DialogContent>
                        <DialogActions>
                            <button className=" btn-2 btn d-flex btn-primary search-btn  " type="button" onClick={handleDocClose}  >Cancel</button>

                        </DialogActions>
                    </React.Fragment>
                </div>
            </Dialog>
        );
    }
     const handleRemoveUploadedDoc = async (rowData: any) => {

        const resDlg = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        })

        if (!resDlg.isConfirmed) {
            return;
        }

        setloading(true);
        try {
            // Check if this is a grouped document row or single document
            let documentsToDelete: UploadedDocumentType[] = [];
            
            if (rowData.allDocuments && Array.isArray(rowData.allDocuments)) {
                // This is a grouped document row
                documentsToDelete = rowData.allDocuments;
            } else if (rowData.customerPolicyDocumentId) {
                // This is a single document
                documentsToDelete = [rowData];
            } else {
                throw new Error('Invalid document data structure');
            }

            // Delete all documents
            const deletePromises = documentsToDelete.map((doc: UploadedDocumentType) => 
                apiClient(`/customer/DeleteUploadedDocument?customerPolicyDocumentId=${doc.customerPolicyDocumentId}`, {
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    }),
                    method: "Delete",
                })
            );
            
            await Promise.all(deletePromises);
            await Promise.all([
                getUploadedDocuments(),
                getRevertedDocuments(),
                fetchRequiredDocumentName()
            ]);
            await new Promise(resolve => setTimeout(resolve, 100));
            setRefreshKey(prev => prev + 1);

            const successMessage = documentsToDelete.length > 1 
                ? `All ${documentsToDelete.length} documents have been successfully deleted.`
                : 'The document has been successfully deleted.';

            Swal.fire({
                icon: 'success',
                title: 'Deleted Successfully!',
                text: successMessage,
                confirmButtonText: 'OK'
            });
        }
        catch (error) {
            console.error('Delete error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Delete Failed',
                text: 'Some documents could not be deleted. Please try again.',
                confirmButtonText: 'OK'
            });
        } finally {
            setloading(false);
        }
    }

    const fetchStates = () => {

        apiClient('/FilingsByUser/getUserFilingStates',
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }).then((responseJson) => {
                if (!responseJson) return
                setStates(responseJson.data)
            })
    }

    const handleStateChange = (event: number) => {

        apiClient(`/InsuranceCompany/getPartnerInsuranceCompanyByState?stateId=${event}`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }).then((responseJson) => {
                if (!responseJson) return

                setCarriers(responseJson.data)
                getLineOfbusiness(event);

            }).finally(() => {
                setloading(false);
            });
    };
    const getLineOfbusiness = (stateId: number | undefined) => {
        apiClient(`/LineOfBusiness/getLineOBusinessByStateId?stateId=${stateId}`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }).then((responseJson) => {
                if (!responseJson) return
                setLOB(responseJson.data)

            }).finally(() => {
                setloading(false);
            });
    }

    const [insuranceId, setInsuranceId] = useState<string>('');
    const baseStyle = {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        padding: '10px',
        borderWidth: 1,
        borderRadius: 8,
        borderColor: '#41729F',
        borderStyle: 'dashed',
        cursor: 'pointer',


        backgroundColor: '#fafafa',
        color: '#41729F',
        outline: 'none',
        transition: 'border .24s ease-in-out'
    };

    const focusedStyle = {
        borderColor: '#2196f3'
    };

    const acceptStyle = {
        borderColor: '#00e676'
    };

    const rejectStyle = {
        borderColor: '#ff1744'
    };
    var formData = new FormData();
    interface CustomProps {
        onChange: (event: { target: { name: string; value: string } }) => void;
        name: string;
    }

    const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(
        function NumericFormatCustom(props, ref) {
            const { onChange, ...other } = props;

            return (
                <NumericFormat
                    {...other}
                    getInputRef={ref}
                    onValueChange={(values) => {
                        onChange({
                            target: {
                                name: props.name,
                                value: values.value,
                            },
                        });
                    }}
                    thousandSeparator
                    valueIsNumericString
                    prefix="$"
                />
            );
        },
    );



    function GenericStyledDropZone(props: any & ReqDocuments) {
        const maxLength = 20;
        const { limitSize = 10 } = props

        const onDropRejected = (fileRejections: FileRejection[]) => {
            const first = fileRejections?.[0]
            const errCodes = first?.errors?.map((e) => e.code) || []

            if (errCodes.includes('file-too-large')) {
                Swal.fire({
                    icon: 'error',
                    title: 'File too large',
                    text: `Maximum file size ${limitSize}MB.`,
                    confirmButtonText: 'OK'
                })
                return
            }
            if (errCodes.includes("file-invalid-type")) {
                Swal.fire({
                    icon: 'error',
                    title: 'Invalid file type',
                    text: `Only .pdf, Word, and image files are allowed.`,
                    confirmButtonText: 'OK'
                })
                return
            }
            Swal.fire({
                icon: 'error',
                title: 'Upload failed',
                text: `Please check your file and try again.`,
                confirmButtonText: 'OK'
            })
        }

        const {
            getRootProps,
            getInputProps,
            acceptedFiles,
            isFocused,
            isDragAccept,
            isDragReject,
        } = useDropzone({
            maxFiles: 10,
            maxSize: limitSize * 1024 * 1024,
            disabled: policyReadOnlyFromCompleted,
            accept: { 'application/pdf': ['.pdf'], 'image/*': [], 'application/msg': ['.msg'] },
            onDrop: (files) => {
                const file = files?.[0]
                if (!file) return

                const regex = new RegExp(`^${props?.doc?.documentTypeId}__.+$`)
                formData.forEach((value, key) => {
                    if (regex.test(key)) {
                        formData.delete(key); // Delete keys matching srdmId pattern
                    }
                });
                files.map((file) => {
                    formData.append(props?.doc?.documentTypeId + "__" + file.name, file);
                });
            },
            onDropRejected,
        });

        const style = useMemo(() => ({
            ...baseStyle,
            ...(isFocused ? focusedStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {})
        }), [
            isFocused,
            isDragAccept,
            isDragReject
        ]);

        const files = acceptedFiles.map(file => (
            <React.Fragment >
                <span style={{ fontSize: "14px" }}>
                    {file?.name?.length > 35 ? file?.name?.substring(0, 35) + '...' : file?.name}
                </span>
                <br />
            </React.Fragment>
        ));

        return (
            <React.Fragment>
                <div className=" box-style col-lg-12">
                    <div {...getRootProps({ style })}>
                        <input {...getInputProps()} name={props?.doc?.documentName} />
                        <p style={{ fontSize: "16px", color: "#162E3C", fontWeight: "600" }}>Upload  {props?.doc?.documentName === '' || props?.doc?.documentName === null || props?.doc?.documentName === undefined ? " documents for storage" : props?.doc?.documentName}
                            <span style={{ color: "red" }}>{props?.doc?.isRequired ? "*" : ""}</span></p>
                    </div>
                    <span >
                        <p style={{ height: "20px", textAlign: "start", margin: 2 }}>{files}</p>
                    </span>
                </div>
            </React.Fragment>
        );
    }

    const { openDialog_Message } = useAppDialog()
    const handleSendMessage = async (CustomerPolicyId: number, status: string) => {
        try {
            setloading(true);
            openDialog_Message({
                custPolId: String(CustomerPolicyId)
            }).then((res: DialogResponse) => {
                if (res.dialogResult === DialogResult.OK) {

                }
                return res
            })
            setloading(false);
        } catch (error) {
            setloading(false);
        }
    };
    function RevertDocument(
        documentTypeId: number,
        documentName: string | undefined,
        customerPolicyDocumentId: number
    ) {
        const isRevertExist = revertDocument.some((val) => val.documentTypeId === documentTypeId);
        if (!isRevertExist || true) {
            setRevertDocument((prev) => [...prev,  { documentTypeId, customerPolicyDocumentId, isRevert: true},]);
        } else {
            setRevertDocument((prev) =>
                prev.filter((val) => val.documentTypeId !== documentTypeId || val.customerPolicyDocumentId !== customerPolicyDocumentId)
            );
        }
    }

    const handleRevert = (documentDetails: any, isAll: boolean) => {
        Swal.fire({
            title:'Send Back to Client',
            text: `Are you sure you want to Send Back to Client ?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#007BFF',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            padding: '20px',
            backdrop: true,
            customClass: {
                popup: 'custom-swal-popup',
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
            },
            width: '500px',
        })
        .then((result) => {
            if (result.isConfirmed) {
                documentDetails.forEach((doc:any) => {
                    RevertDocument(doc.documentTypeId, doc.documentName, doc.customerPolicyDocumentId);
                });
                handleSendMessage(Number(params.CustomerPolicyId), getPolicyStatus || "")
            }
        })
    };

    function ViewDocuments(props: { docTypeId: number | undefined }) {
        const value = UploadedDocument.find((item) => item.documentTypeId === props.docTypeId);
        const isRevertExist = revertDocument.some((val) => val.documentTypeId === value?.documentTypeId);
        return (
            <>
                {value ? (
                    <div className="box-style col-lg-12">
                        <Tooltip title={`Download ${value.documentName.split("_").slice(1).join("_")}`} arrow>
                            <Link
                                href={value.blob_Address}
                                sx={{ textDecoration: "none", display: "flex", alignItems: "center" }}
                                target="_blank"
                            >
                                <div
                                    role="presentation"
                                    tabIndex={0}
                                    style={{
                                        flex: "1 1 0%",
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "10px",
                                        borderWidth: "1px",
                                        borderRadius: "8px",
                                        borderColor: "rgb(65, 114, 159)",
                                        borderStyle: "dashed",
                                        backgroundColor: "rgb(250, 250, 250)",
                                        color: "rgb(65, 114, 159)",
                                        outline: "none",
                                        transition: "border 0.24s ease-in-out",
                                    }}
                                >
                                    <span style={{ marginRight: "8px" }}>
                                        <p>{value.name}</p>
                                    </span>
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 22 22"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M19.25 13.75V17.4167C19.25 17.9029 19.0568 18.3692 18.713 18.713C18.3692 19.0568 17.9029 19.25 17.4167 19.25H4.58333C4.0971 19.25 3.63079 19.0568 3.28697 18.713C2.94315 18.3692 2.75 17.9029 2.75 17.4167V13.75M6.41667 9.16667L11 13.75M11 13.75L15.5833 9.16667M11 13.75V2.75"
                                            stroke="#02A4E3"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        ></path>
                                    </svg>
                                </div>
                            </Link>
                        </Tooltip>
                        <p
                            style={{
                                flex: 1, 
                                height: "auto", 
                                wordBreak: "break-word", 
                                textAlign: "start",
                                margin: "2px",
                                color: "#555",
                            }}
                        >
                            {value.documentName.split("_").slice(1).join("_")}
                        </p>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px" }}>
                            <IconButton 
                                color="error" 
                                onClick={() => handleRemoveUploadedDoc(value)}
                                size="small"
                                title="Delete Document"
                                disabled={policyReadOnlyFromCompleted}
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 6H5M5 6H21M5 6V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V6H5ZM8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6" stroke="#162E3C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </IconButton>
                            {AppFlags  && data?.isClient ? 
                                <button
                                    className={`${ isRevertExist ? 'active-btn-red' : 'active-btn-blue'} me-2`}
                                    type="button"
                                    onClick={() => handleRevert([value], false)}
                                    disabled={isRevertExist || policyReadOnlyFromCompleted}
                                >
                                    Revert
                                </button>
                            : null}
                        </div>
                    </div>
                ) : null}
            </>
        );
    }
    
    const handlePatnerChange = (event: SelectChangeEvent) => {
        setPartnerId(event.target.value);
    };

    const handleStateOptionChange = (event: SelectChangeEvent) => {
        setSelectedLOB('');
        setInsuranceId('')
        setSelectedStateOption(event.target.value);
        handleStateChange(Number(event.target.value));
    };
    const handleInsuranceChange = (event: SelectChangeEvent) => {

        setInsuranceId(event.target.value);
    };
    const handleTransactionChange = (event: SelectChangeEvent) => {

        setselectedTransaction(event.target.value);
    };
    const handleLOBChange = (event: SelectChangeEvent) => {
        setSelectedLOB(event.target.value ?? '');
    };

    const [getPolicyStatus, setPolicyStatus] = React.useState<string>('');
    const policyStatus = [
        'Missing Documents', 'Pending Documents', 'Flagged', 'Ready to File', 'Pending Autofile', 'Pending state review', 'State Flagged', 'Filed', 'IsClosed', 'Not Started'
    ]

    const handlePolicyStatus = (event: SelectChangeEvent) => {
        setPolicyStatus(event.target.value);
    };

    const handleDeleteRow = async (index: number) => {
        const rows = CustTaxAndFees ?? [];
        const row = rows[index];
        const isRowEmpty = isTaxRowEmpty(row);

        if ((rows ?? []).length <= 1 && isRowEmpty) {
            return;
        }

        if (!isRowEmpty) {
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: 'This tax type will be removed.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#02A4E3',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Delete',
                customClass: {
                    confirmButton: 'btn-radius',
                    cancelButton: 'btn-radius',
                }
            });
            if (!result.isConfirmed) {
                return;
            }
        }

        const existingId = Number(row?.customerPolicyTaxesAndFeesId ?? 0);
        if (existingId > 0) {
            setDeletedTaxAndFeeIds((ids) => (
                ids.includes(existingId) ? ids : [...ids, existingId]
            ));
        }
        if ((rows ?? []).length <= 1) {
            setCustTaxAndFees([createTaxAndFeeRow()]);
            return;
        }
        const updatedArray = rows.filter((_, idx) => idx !== index);
        setCustTaxAndFees(updatedArray);

    };
    const handleTaxPayeeChange = (index: number, value: string) => {
        setCustTaxAndFees((prev) => {
            const arr = [...(prev ?? [])];
            if (!arr[index]) return prev;
            arr[index] = { ...arr[index], payee: value };
            return arr;
        });
    };
    const handleTaxAmountChange = (index: number, value: string) => {
        setCustTaxAndFees((prev) => {
            const arr = [...(prev ?? [])];
            if (!arr[index]) return prev;
            arr[index] = { ...arr[index], amount: value };
            return arr;
        });
    };
    const handleTaxNameChange = (e: any, index: number) => {
        const taxName = e.target.value;
        setCustTaxAndFees((prev) => {
            const arr = [...(prev ?? [])];
            if (!arr[index]) return prev;
            if (!String(taxName ?? "").trim()) {
                arr[index] = {
                    ...arr[index],
                    taxName,
                    payee: "",
                    amount: "",
                    paymentPeriod: "",
                };
            } else {
                arr[index] = { ...arr[index], taxName };
            }
            return arr;
        });
    };

    function fetchRequiredDocumentName() {
        setloading(true);
        return apiClient(`/customer/getRequiredDocuments?customerPolicyId=${params.CustomerPolicyId}&all=1`,
            {
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }).then((res) => {
                if (!res) return
                setRequiredDocuments(res.data);

            }).finally(() => {
                setloading(false);
            });
    }

    useEffect(() => {
        if (!params.CustomerPolicyId) return

        fetchRequiredDocumentName();
    }, [params]);

    const updateDocuments = (data: any, setSubmitting: any) => {
        let count = 0
        formData.forEach(element => {
            count = count + 1;
        });
        if (count < 1) {
            alert("select a document");
            setSubmitting(false);
            setloading(false);

            return;

        } else {
            setloading(true);
            formData.append('transactionTypeId', data.transactionTypeId.toString() ?? "");
            let ID = params.customerPolicyId?.toString() ?? "";
            formData.append('CustomerPolicyId', ID);

            apiClient(`/CustomerPolicy/CorrectedDocumentSubmission/`,
                {
                    method: 'POST',
                    headers: new Headers({
                        'Authorization': `Bearer ${token}`,
                    }),
                    body: formData
                })
                .then((res) => {
                    if (!res) return
                    if (res.resp == 200) {
                    } else {
                        alert(res.data);
                    }
                }).finally(() => {
                    setSubmitting(false);
                    formData = new FormData();
                    setloading(false);
                });
        }
    }

    const handlDeletePolicy = () => {
        setloading(true);
        Swal.fire({
            title: 'Are you sure, you want to delete this filing?',
            text: "You won't be able to revert this!",
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        })
            .then((result) => {
                if (result.isConfirmed) {
                    apiClient("/CustomerPolicy/DeleteCustomerPolicy?id=" + `${params.CustomerPolicyId}`,
                        {
                            headers: new Headers({
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                            }),
                            method: "Delete",
                        }
                    ).then((res) => {
                        if (!res) return
                        if (res.status) {
                            Swal.fire(
                                'Deleted!',
                                'Transaction has been deleted.',
                                'success')
                                .then(() => {
                                    navigate(AppRoutes.root);
                                })
                        }
                    }).finally(() => {
                        setloading(false);
                    });
                }
                setloading(false);
            })
    };
    const validationSchema = Yup.object().shape({
        selectedLOB: Yup.string().nullable(),
        insuranceId: Yup.string().nullable(),
    });

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <React.Fragment>
                <Formik
                    enableReinitialize={true}
                    initialValues={{
                        ...CustomerPolicyDetails,
                        nAIC: CustomerPolicyDetails?.nAIC || '',
                        selectedLOB: selectedLOB ?? '',
                        insuranceId: insuranceId
                     }}
                    validationSchema={validationSchema} 
                    onSubmit={(data, { setSubmitting }) => {
                        if (policyReadOnlyFromCompleted) {
                            setSubmitting(false);
                            return;
                        }
                        setloading(true);
                        formData = new FormData();
                        data.customerPolicyId = Number(params.CustomerPolicyId);
                        {
                            const rawId = insuranceId != null ? String(insuranceId).trim() : '';
                            const parsed = rawId !== '' ? Number(rawId) : NaN;
                            const hasCarrier = !Number.isNaN(parsed) && parsed > 0;
                            if (hasCarrier) {
                                data.insuranceCompanyId = parsed;
                            } else {
                                data.insuranceCompanyId = 0;
                            }
                            if (data.insuranceCompanyId === 0) {
                                data.carrier = '';
                            }
                        }
                        data.stateId = selectedStateOption;
                        data.transactionId = Number(selectedTransaction);
                        data.lobId = Number(selectedLOB);
                        data.partnersId = Number(partnerId);

                        data.status = getPolicyStatus;
                        if ((revertDocument ?? []).length > 0) {
                            data.status = 'Waiting on Client';
                        }
                        const updatedTaxAndFees = (CustTaxAndFees ?? []).map((element) => ({ ...element }));
                        const removedByEmptyTaxName = updatedTaxAndFees
                            .filter((element) => (compactString(element.taxName ?? '') ?? '').length === 0 && Number(element.customerPolicyTaxesAndFeesId ?? 0) > 0)
                            .map((element) => Number(element.customerPolicyTaxesAndFeesId ?? 0));
                        const cleanedTaxAndFees = updatedTaxAndFees.filter((element) => (compactString(element.taxName ?? '') ?? '').length > 0);

                        const normalizedTaxNames = cleanedTaxAndFees.map((element) => compactString(element.taxName ?? '') ?? '');
                        const duplicateTaxNames = normalizedTaxNames.filter((name, idx) => normalizedTaxNames.indexOf(name) !== idx);
                        if (duplicateTaxNames.length > 0) {
                            setSubmitting(false);
                            setloading(false);
                            Swal.fire({
                                title: 'Duplicate Tax Type',
                                text: 'Duplicate Tax Types are not allowed. Please keep only one row per Tax Type.',
                                icon: 'warning',
                                confirmButtonColor: '#02A4E3',
                                confirmButtonText: 'Ok',
                            });
                            return;
                        }

                        setCustTaxAndFees(cleanedTaxAndFees.length > 0 ? cleanedTaxAndFees : [createTaxAndFeeRow()]);
                        data.customerPolicyTaxAnFee = cleanedTaxAndFees;
                        data.deletedCustomerPolicyTaxesAndFeesIds = Array.from(new Set([...(deletedTaxAndFeeIds ?? []), ...removedByEmptyTaxName]));
                        // Serialize date fields to ISO for API (calendar date → midnight MST in UTC)
                        const toIso = (v: unknown) => {
                            if (v == null || v === '') return '';
                            if (dayjs.isDayjs(v)) return pickerDateToUtcIsoStringForMst((v as dayjs.Dayjs).toDate());
                            if (typeof v === 'string') {
                                const s = v.trim();
                                if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return dateOnlyStringToUtcIsoString(s);
                                if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(s)) return mstDateStringToUtcIsoString(s);
                            }
                            return typeof v === 'string' ? v : '';
                        };
                        if (data.policyEffDate != null) data.policyEffDate = toIso(data.policyEffDate) as any;
                        if (data.policyExpDate != null) data.policyExpDate = toIso(data.policyExpDate) as any;
                        if (data.invDate != null) data.invDate = toIso(data.invDate) as any;
                        {
                            const rawBinder = data.filedBinderDate;
                            if (
                                rawBinder == null ||
                                rawBinder === "" ||
                                (typeof rawBinder === "string" && rawBinder.trim() === "")
                            ) {
                                data.filedBinderDate = null;
                            } else {
                                const isoBinder = toIso(rawBinder);
                                data.filedBinderDate = isoBinder !== "" ? isoBinder : null;
                            }
                        }
                        formData.append("data", JSON.stringify(data)); // Add the main data object
                        const revertPayload = (revertDocument ?? []).map(x => ({
                            documentTypeId: x.documentTypeId,
                            customerPolicyDocumentId: x.customerPolicyDocumentId,
                            isRevert: 1
                        }));
                        formData.append("revertDocument", JSON.stringify(revertPayload));
                        apiClient(`/CustomerPolicy/UpdateCustomerPolicyDetails`,
                            {
                                method: 'POST',
                                headers: new Headers({
                                    'Authorization': `Bearer ${token}`,
                                }),
                                body: formData

                            })
                            .then((res) => {
                                if (res.resp == 0) {
                                    Swal.fire({
                                        title: "Data Successfully Updated",
                                        text: "success",
                                        icon: "success",
                                        confirmButtonColor: '#02A4E3',
                                        confirmButtonText: 'Ok',
                                        customClass: {
                                            popup: 'custom-success-popup',
                                            title: 'custom-success-title',
                                            htmlContainer: 'custom-success-content',
                                            confirmButton: 'custom-success-button'
                                        },
                                        showConfirmButton: true,
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            if ((revertDocument ?? []).length > 0) {
                                                try {
                                                    apiClient(`/PolicyDashBoard/updateCustomerPolicyStatus`, {
                                                        method: 'POST',
                                                        headers: new Headers({
                                                            'Content-Type': 'application/json',
                                                            'Authorization': `Bearer ${token}`,
                                                        }),
                                                        body: JSON.stringify({
                                                            customerPolicyId: Number(params.CustomerPolicyId),
                                                            status: 'Waiting on Client'
                                                        })
                                                    })
                                                } catch {}
                                            }
                                            fetchData();
                                            fetchCustomerPolicyTaxAndFees();
                                            fetchTaxAndFeesOptions();
                                        }
                                    });
                                }
                            }).finally(() => {
                                setSubmitting(false);
                                setloading(false);
                            });

                    }} >
                    {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) =>
                    (
                        <Form className="main-form">
                            {loading && <LinearProgress style={{ margin: 2 }} />}
                            <Box sx={{ pb: 3 }}>
                                <Box sx={{ mb: 2 }}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            gap: 1.5,
                                            px: 2,
                                            py: 2.5,
                                            borderBottom: "1px solid #e2e8f0",
                                            backgroundColor: "#fafbfc",
                                            minHeight: 56,
                                            mb: 3,
                                        }}
                                    >
                                        <Typography component="h2" variant="h5" sx={{ fontWeight: 600, color: '#0f172a' }}>
                                            Update Transaction Data
                                        </Typography>
                                    </Box>

                                    <Grid container spacing={3} sx={{ mb: 3 }}>
                                        <Grid item xs={12}>
                                            <Typography variant="overline" sx={sectionTitleSx}>Transaction & Selection</Typography>
                                            <Paper variant="outlined" sx={paperSectionSx}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <FormControl sx={{ width: '100%' }} size="small">
                                                            <FormHelperText className="formtexthelper-heading">Select State</FormHelperText>
                                                            <Select
                                                                labelId="State-Select-Label"
                                                                onChange={handleStateOptionChange}
                                                                value={selectedStateOption}
                                                                disabled={isAdminOnlyFieldDisabled}
                                                                IconComponent={ExpandMoreIcon}
                                                                sx={selectFieldSx}
                                                            >
                                                                {States?.map((val, key) =>
                                                                    <MenuItem key={key} value={val.stateId}> {val.stateName} </MenuItem>
                                                                )}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <FormControl sx={{ width: '100%' }} size="small">
                                                            <FormHelperText className="formtexthelper-heading">Select Client</FormHelperText>
                                                            <Autocomplete
                                                                sx={{
                                                                    '& .MuiFormLabel-root': { transform: 'translate(1px, -28px) scale(1)', fontSize: '16px !important', color: '#212529 !important', fontWeight: '400 !important' },
                                                                    '& .MuiInputBase-root': { padding: '3.5px 9px' },
                                                                    '& .MuiOutlinedInput-notchedOutline': { borderRadius: '8px', border: '2px solid #e2e8f0', padding: '12px 16px', top: '-5px'},
                                                                    // paddingTop: '30px'
                                                                }}
                                                                options={getPartners ?? []}
                                                                getOptionLabel={(option) => option.customerName ?? ""}
                                                                onChange={(event, value) => {
                                                                    setPartnerId(String(value?.partnersId ?? ""));
                                                                }}
                                                                value={getPartners?.find(item => item.partnersId === Number(partnerId)) ?? null}
                                                                disabled={isAdminOnlyFieldDisabled}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        sx={{
                                                                            ".MuiFormLabel-root.Mui-focused": {
                                                                                color: (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0) ? "#000" : "#cccccc !important",
                                                                            },
                                                                            // '& .MuiInputBase-root': { marginTop: '5px !important' },
                                                                            '& .MuiOutlinedInput-root': { padding: '3.5px 9px' },
                                                                            '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
                                                                            '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
                                                                        }}
                                                                        {...params}
                                                                        label={null}
                                                                        InputLabelProps={{ ...params.InputLabelProps, shrink: (!!partnerId && partnerId !== "0") || (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0) ? true : false }}
                                                                    />
                                                                )}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <FormControl sx={{ width: '100%' }} size="small" error={touched.insuranceId && Boolean(errors.insuranceId)}>
                                                            <FormHelperText className="formtexthelper-heading">Select Carrier</FormHelperText>
                                                            <Autocomplete
                                                                sx={{
                                                                    '& .MuiFormLabel-root': { transform: 'translate(1px, -28px) scale(1)', fontSize: '16px !important', color: '#212529 !important', fontWeight: '400 !important' },
                                                                    '& .MuiInputBase-root': { padding: '3.5px 9px' },
                                                                    '& .MuiOutlinedInput-notchedOutline': { borderRadius: '8px', border: '2px solid #e2e8f0', padding: '12px 16px', top: '-5px'},
                                                                }}
                                                                options={carriers ?? []}
                                                                getOptionLabel={(option) => option.insuranceCompanyName ?? ""}
                                                                onChange={(event, value) => {
                                                                    setInsuranceId(String(value?.insuranceCompanyId ?? ""));
                                                                }}
                                                                value={carriers?.find(item => item.insuranceCompanyId === Number(insuranceId)) ?? null}
                                                                disabled={isAdminOnlyFieldDisabled}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        sx={{
                                                                            ".MuiFormLabel-root.Mui-focused": {
                                                                                color: (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0) ? "#000" : "#cccccc !important",
                                                                            },
                                                                            '& .MuiOutlinedInput-root': { padding: '3.5px 9px' },
                                                                            '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
                                                                            '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
                                                                        }}
                                                                        {...params}
                                                                        label={null}
                                                                        name="selectedLOB"
                                                                        onBlur={handleBlur}
                                                                        InputLabelProps={{ ...params.InputLabelProps, shrink: (!!insuranceId && insuranceId !== "0") || (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0) ? true : false }}
                                                                    />
                                                                )}
                                                            />
                                                            {touched.insuranceId && errors.insuranceId && (
                                                                <FormHelperText>{errors.insuranceId}</FormHelperText>
                                                            )}
                                                        </FormControl>
                                                    </Grid>
                                                    {/* <Grid item xs={12} sm={6} md={4}>
                                                        <FormControl sx={{ width: '100%' }} size="small">
                                                            <FormHelperText className="formtexthelper-heading">Select Client</FormHelperText>
                                                            <Select
                                                                labelId="demo-simple-select-partner"
                                                                onChange={handlePatnerChange}
                                                                disabled={isAdminOnlyFieldDisabled}
                                                                value={partnerId}
                                                                IconComponent={ExpandMoreIcon}
                                                                sx={selectFieldSx}
                                                            >
                                                                {getPartners?.map((val, key) =>
                                                                    <MenuItem key={key} value={val.partnersId}> {val.customerName} </MenuItem>
                                                                )}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid> */}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <FormControl sx={{ width: '100%' }} size="small">
                                                            <FormHelperText className="formtexthelper-heading">Select Transaction</FormHelperText>
                                                            <Select
                                                                labelId="demo-simple-select-tran"
                                                                onChange={handleTransactionChange}
                                                                disabled={isAdminOnlyFieldDisabled}
                                                                value={selectedTransaction}
                                                                IconComponent={ExpandMoreIcon}
                                                                sx={selectFieldSx}
                                                            >
                                                                {TransactionType?.map((val, key) =>
                                                                    <MenuItem key={key} value={val.transactionId}> {val.transactionTypeName} </MenuItem>
                                                                )}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <FormControl sx={{ width: '100%' }} size="small" error={touched.selectedLOB && Boolean(errors.selectedLOB)}>
                                                            <FormHelperText className="formtexthelper-heading">Select line of business</FormHelperText>
                                                            <Autocomplete
                                                                sx={{
                                                                    '& .MuiFormLabel-root': { transform: 'translate(1px, -28px) scale(1)', fontSize: '16px !important', color: '#212529 !important', fontWeight: '400 !important' },
                                                                    '& .MuiInputBase-root': { padding: '3.5px 9px' },
                                                                    '& .MuiOutlinedInput-notchedOutline': { borderRadius: '8px', border: '2px solid #e2e8f0', padding: '12px 16px', top: '-5px'},
                                                                }}
                                                                options={LOB ?? []}
                                                                getOptionLabel={(option) => option.businessCode ?? ""}
                                                                onChange={(event, value) => {
                                                                    setSelectedLOB(value?.id != null ? String(value.id) : '');
                                                                }}
                                                                value={LOB?.find(item => item.id === Number(selectedLOB)) ?? null}
                                                                disabled={isAdminOnlyFieldDisabled}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        sx={{
                                                                            ".MuiFormLabel-root.Mui-focused": {
                                                                                color: (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0) ? "#000" : "#cccccc !important",
                                                                            },
                                                                            '& .MuiInputBase-root': { marginTop: '5px !important' },
                                                                            '& .MuiOutlinedInput-root': { padding: '3.5px 9px' },
                                                                            '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
                                                                            '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
                                                                        }}
                                                                        {...params}
                                                                        label={null}
                                                                        id="selectedLOB"
                                                                        name="selectedLOB"
                                                                        onBlur={handleBlur}
                                                                        InputLabelProps={{ ...params.InputLabelProps, shrink: (!!selectedLOB && selectedLOB !== '0') || (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0) ? true : false }}
                                                                    />
                                                                )}
                                                            />
                                                            {touched.selectedLOB && errors.selectedLOB && (
                                                                <FormHelperText>{errors.selectedLOB}</FormHelperText>
                                                            )}
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Typography variant="overline" sx={sectionTitleSx}>Policy</Typography>
                                            <Paper variant="outlined" sx={paperSectionSx}>
                                                <Grid container spacing={2}>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl
                                            disabled={isAdminOnlyFieldDisabled}
                                            sx={{ width: '100%' }} >
                                            <FormHelperText
                                                className='formtexthelper-heading' >
                                                Invoice Number
                                            </FormHelperText>
                                            <FMTextField name="invoiceNumber"
                                                disabled={isAdminOnlyFieldDisabled}
                                                InputLabelProps={{ shrink: true }} label={null} type="Text" fullWidth variant="outlined" sx={textFieldSx} />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                Policy Number
                                            </FormHelperText>
                                            <FMTextField
                                                name="policyNumber"
                                                disabled={isPolicyNumberDisabled}
                                                InputLabelProps={{ shrink: true }} label={null} type="Text" fullWidth variant="outlined" sx={textFieldSx} />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormHelperText className='formtexthelper-heading' >Policy Effective Date</FormHelperText>
                                        <DatePicker
                                            inputFormat="MM/DD/YYYY"
                                            label={null}
                                            disabled={isAdminOnlyFieldDisabled}
                                            // className="select-input-border text-input-box"
                                            value={values.policyEffDate ? (typeof values.policyEffDate === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(values.policyEffDate) ? dayjs(values.policyEffDate, "YYYY-MM-DD") : dayjs(values.policyEffDate)) : null}
                                            onChange={(v) =>
                                                setFieldValue("policyEffDate", v)
                                            }
                                            // value={EffectiveDate}
                                            // onChange={(v) => effectiveDateStartChnage(v ?? "")}
                                            renderInput={(params) => (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                    id="effectiveDateStart"
                                                    name="policyEffDate"
                                                    sx={textFieldSx} />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormHelperText className='formtexthelper-heading' >Expiration Date</FormHelperText>
                                        <DatePicker
                                            inputFormat="MM/DD/YYYY"
                                            label={null}
                                            // className="select-input-border text-input-box"
                                            disabled={isAdminOnlyFieldDisabled}
                                            value={values.policyExpDate ? (typeof values.policyExpDate === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(values.policyExpDate) ? dayjs(values.policyExpDate, "YYYY-MM-DD") : dayjs(values.policyExpDate)) : null}
                                            onChange={(v) =>
                                                setFieldValue("policyExpDate", v)
                                            }
                                            // value={ExpDate}
                                            // onChange={(v) => expDataHandleChange(v ?? "")}
                                            renderInput={(params) => (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                    name="policyExpDate"
                                                    sx={textFieldSx} />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormHelperText className='formtexthelper-heading' >Invoice Date</FormHelperText>
                                        <DatePicker
                                            inputFormat="MM/DD/YYYY"
                                            label={null}
                                            // className="select-input-border text-input-box"
                                            disabled={isAdminOnlyFieldDisabled}
                                            value={values.invDate ? (typeof values.invDate === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(values.invDate) ? dayjs(values.invDate, "YYYY-MM-DD") : dayjs(values.invDate)) : null}
                                            onChange={(v) =>
                                                setFieldValue("invDate", v)
                                            }
                                            // onChange={(v) => InvoiceDateHandleChange(v ?? "")}
                                            renderInput={(params) => (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                    name="invDate"
                                                    sx={{...textFieldSx, '& .MuiInputBase-input' : { padding: '5px 14px !important' } }} />
                                            )}
                                        />
                                    </Grid>



                                    {/* <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormHelperText className='formtexthelper-heading' >Date Filed</FormHelperText>
                                        <DatePicker
                                            inputFormat="MM/DD/YYYY"
                                            label={null}
                                            className="select-input-border text-input-box"
                                            value={DateFiled}
                                            disabled={isAdminOnlyFieldDisabled}
                                            onChange={(v) => dateFiledHandleChange(v ?? "")}
                                            renderInput={(params) => (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                    name="dateFiled" />
                                            )}
                                        />
                                    </Grid> */}

                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                NAIC
                                            </FormHelperText>
                                            <FMTextField
                                                name="nAIC"
                                                disabled={isAdminOnlyFieldDisabled}
                                                InputLabelProps={{ shrink: true }} label={null} type="Text" fullWidth variant="outlined" sx={textFieldSx} />

                                        </FormControl>
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                Filing Due Date
                                            </FormHelperText>
                                            <FMTextField name="policyFilingDueDate" disabled InputLabelProps={{ shrink: true }} label={null} type="Text" fullWidth variant="outlined" sx={textFieldSx} />

                                        </FormControl>
                                        {/* <FormHelperText className='formtexthelper-heading' >Filing Due Date</FormHelperText>
                                        <DatePicker
                                            inputFormat="MM/DD/YYYY"
                                            label={null}
                                            className="select-input-border text-input-box"
                                            value={FilingDueDate}
                                            onChange={(v) => handleChangeFilingDueDate(v ?? "")}
                                            renderInput={(params) => (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                    name="policyFilingDueDate" />
                                            )}
                                        /> */}
                                    </Grid>
                                    { (selectedTransaction == '29' || selectedTransaction == '8' || selectedTransaction == '9' || selectedTransaction == '10') && (
                                        <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                            <FormControl sx={{ width: '100%' }} >
                                                <FormHelperText className='formtexthelper-heading' >
                                                    Parent Policy {values.parentPolicyId ? <Link href={`/Admin/AddEditCustomerPolicyDetails/${values.parentPolicyId}`}>Link</Link> : 'Link'}
                                                </FormHelperText>
                                                <FMTextField name="parentPolicyNumber" disabled InputLabelProps={{ shrink: true }} label={null} type="Text" fullWidth variant="outlined" sx={textFieldSx} />
                                            </FormControl>
                                        </Grid>
                                    )}
                                                </Grid>
                                            </Paper>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Typography variant="overline" sx={sectionTitleSx}>Insured</Typography>
                                            <Paper variant="outlined" sx={paperSectionSx}>
                                                <Grid container spacing={2}>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                Insured Name
                                            </FormHelperText>
                                            <FMTextField
                                                name="insuredName"
                                                disabled={isAdminOnlyFieldDisabled}
                                                InputLabelProps={{ shrink: true }} label={null} type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                        </FormControl>
                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Typography variant="overline" sx={sectionTitleSx}>Premium & Taxes</Typography>
                                            <Paper variant="outlined" sx={paperSectionSx}>
                                                <Grid container spacing={2}>
                                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                        <FormControl sx={{ width: '100%' }} >
                                                            <FormHelperText className='formtexthelper-heading' >
                                                                Premium
                                                            </FormHelperText>
                                                            <FMTextField
                                                                label={null}
                                                                type="text"
                                                                name="grossPremium"
                                                                id="formatted-numberformat-input"
                                                                InputProps={{
                                                                    inputComponent: NumericFormatCustom as any,
                                                                }}
                                                                fullWidth variant="outlined"
                                                                disabled={policyReadOnlyFromCompleted}
                                                                sx={{...textFieldSx, '& .MuiInputBase-input' : {textAlign: 'right', padding: '3.5px 14px !important' } }}
                                                            />

                                                            {/* <FMTextField
                                                                name="grossPremium"
                                                                InputLabelProps={{ shrink: true }}
                                                                label={null}
                                                                type="text"
                                                                fullWidth variant="outlined"
                                                                sx={{}}

                                                            /> */}

                                                        </FormControl>
                                                    </Grid>

                                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                        <FormControl sx={{ width: '100%' }} >
                                                            <FormHelperText className='formtexthelper-heading' >
                                                                Non Admitted Premium
                                                            </FormHelperText>
                                                            {/* <FMTextField
                                                                name="nonAdmittedPremium"
                                                                InputLabelProps={{ shrink: true, }}
                                                                label={null} type="Text"
                                                                fullWidth variant="outlined"
                                                            
                                                            /> */}
                                                            <FMTextField
                                                                label={null}
                                                                // value={values.nonAdmittedPremium}
                                                                type="text"
                                                                // onChange={handleChange}
                                                                name="nonAdmittedPremium"
                                                                id="formatted-numberformat-input"
                                                                InputProps={{
                                                                    inputComponent: NumericFormatCustom as any,
                                                                }}
                                                                fullWidth variant="outlined"
                                                                disabled={policyReadOnlyFromCompleted}
                                                                sx={{...textFieldSx, '& .MuiInputBase-input' : {textAlign: 'right', padding: '3.5px 14px !important' } }}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                        <FormControl sx={{ width: '100%' }} >
                                                            <FormHelperText className='formtexthelper-heading' >
                                                                Fee
                                                            </FormHelperText>
                                                            {/* <FMTextField
                                                                name="fee"
                                                                InputLabelProps={{ shrink: true }}
                                                                label={null}
                                                                type="Text"
                                                                fullWidth variant="outlined"
                                                                sx={{}}
                                                            
                                                            /> */}
                                                            <FMTextField
                                                                label={null}
                                                                value={values.fee}
                                                                type="text"
                                                                // onChange={handleChange}
                                                                name="fee"
                                                                id="formatted-numberformat-input"
                                                                InputProps={{
                                                                    inputComponent: NumericFormatCustom as any,
                                                                }}
                                                                fullWidth variant="outlined"
                                                                disabled={policyReadOnlyFromCompleted}
                                                                sx={{...textFieldSx, '& .MuiInputBase-input' : {textAlign: 'right', padding: '3.5px 14px !important' } }}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                        <FormControl sx={{ width: '100%' }} >
                                                            <FormHelperText className='formtexthelper-heading' >
                                                                Stamping Fee
                                                            </FormHelperText>
                                                            <FMTextField
                                                                label={null}
                                                                // value={values.stampingFee}
                                                                type="text"
                                                                // onChange={handleChange}
                                                                name="stampingFee"
                                                                id="formatted-numberformat-input"
                                                                InputProps={{
                                                                    inputComponent: NumericFormatCustom as any,
                                                                }}
                                                                fullWidth variant="outlined"
                                                                disabled={policyReadOnlyFromCompleted}
                                                                sx={{...textFieldSx, '& .MuiInputBase-input' : {textAlign: 'right', padding: '3.5px 14px !important' } }}
                                                            />
                                                            {/* <FMTextField
                                                                name="stampingFee"
                                                                InputLabelProps={{ shrink: true }}
                                                                label={null} type="Text"
                                                                fullWidth variant="outlined"
                                                                sx={{}}
                                                            
                                                            /> */}
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                        <FormControl sx={{ width: '100%' }} >
                                                            <FormHelperText className='formtexthelper-heading' >
                                                                State Tax
                                                            </FormHelperText>
                                                            <FMTextField
                                                                label={null}
                                                                // value={values.stateTax}
                                                                type="text"
                                                                // onChange={handleChange}
                                                                name="stateTax"
                                                                id="formatted-numberformat-input"
                                                                InputProps={{
                                                                    inputComponent: NumericFormatCustom as any,
                                                                }}
                                                                fullWidth variant="outlined"
                                                                disabled={policyReadOnlyFromCompleted}
                                                                sx={{...textFieldSx, '& .MuiInputBase-input' : {textAlign: 'right', padding: '3.5px 14px !important' } }}
                                                            />
                                                            {/* <FMTextField
                                                                name="stateTax"
                                                                InputLabelProps={{ shrink: true }}
                                                                label={null}
                                                                type="Text"
                                                                fullWidth variant="outlined"
                                                            
                                                            /> */}
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                        <FormControl sx={{ width: '100%' }} >
                                                            <FormHelperText className='formtexthelper-heading' >
                                                                Tax Balance
                                                            </FormHelperText>
                                                            <FMTextField
                                                                label={null}
                                                                // value={values.taxBalance}
                                                                type="text"
                                                                // onChange={handleChange}
                                                                name="taxBalance"
                                                                id="formatted-numberformat-input"
                                                                InputProps={{
                                                                    inputComponent: NumericFormatCustom as any,
                                                                }}
                                                                fullWidth variant="outlined"
                                                                disabled={policyReadOnlyFromCompleted}
                                                                sx={{...textFieldSx, '& .MuiInputBase-input' : {textAlign: 'right', padding: '3.5px 14px !important' } }}
                                                            />
                                                            {/* <FMTextField
                                                                name="taxBalance"
                                                                InputLabelProps={{ shrink: true }}
                                                                label={null}
                                                                type="Text"
                                                                fullWidth variant="outlined"
                                                            /> */}
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                        <FormControl sx={{ width: '100%' }} >
                                                            <FormHelperText className='formtexthelper-heading' >
                                                                Taxable Fees
                                                            </FormHelperText>
                                                            <FMTextField
                                                                label={null}
                                                                // value={values.taxableFees}
                                                                type="text"
                                                                // onChange={handleChange}
                                                                name="taxableFees"
                                                                id="formatted-numberformat-input"
                                                                InputProps={{
                                                                    inputComponent: NumericFormatCustom as any,
                                                                }}
                                                                fullWidth variant="outlined"
                                                                disabled={policyReadOnlyFromCompleted}
                                                                sx={{...textFieldSx, '& .MuiInputBase-input' : {textAlign: 'right', padding: '3.5px 14px !important' } }}
                                                            />
                                                            {/* <FMTextField
                                                                name="taxableFees"
                                                                InputLabelProps={{ shrink: true }}
                                                                label={null}
                                                                type="Text"
                                                                fullWidth variant="outlined"
                                                            
                                                            /> */}
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                        <FormControl sx={{ width: '100%' }} >
                                                            <FormHelperText className='formtexthelper-heading' >
                                                                Non Taxable Fees
                                                            </FormHelperText>
                                                            <FMTextField
                                                                label={null}
                                                                // value={values.nonTaxableFees}
                                                                type="text"
                                                                // onChange={handleChange}
                                                                name="nonTaxableFees"
                                                                id="formatted-numberformat-input"
                                                                InputProps={{
                                                                    inputComponent: NumericFormatCustom as any,
                                                                }}
                                                                fullWidth variant="outlined"
                                                                disabled={policyReadOnlyFromCompleted}
                                                                sx={{...textFieldSx, '& .MuiInputBase-input' : {textAlign: 'right', padding: '3.5px 14px !important' } }}
                                                            />
                                                            {/* <FMTextField
                                                                name="nonTaxableFees"
                                                                InputLabelProps={{ shrink: true }}
                                                                label={null}
                                                                type="Text"
                                                                fullWidth variant="outlined"
                                                                InputProps={{
                                                                    inputComponent: NumericFormatCustom as any,
                                                                }}
                                                            /> */}
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        </Grid>

                                        <Grid item xs={12} sx={{ mb: 3 }}>
                                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                                <Typography variant="overline" sx={{ ...sectionTitleSx, mb: 0, alignSelf: 'end', lineHeight: '1.5' }}>Tax Type</Typography>
                                                {staffCanEditTaxAndOperational ? (
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        type="button"
                                                        startIcon={<AddOutlinedIcon />}
                                                        onClick={() => {
                                                            if (!canAddMoreTaxTypes) {
                                                                return;
                                                            }
                                                            setCustTaxAndFees((filingContactArry) => [
                                                                ...(filingContactArry ?? []),
                                                                createTaxAndFeeRow(),
                                                            ]);
                                                        }}
                                                        disabled={!canAddMoreTaxTypes || !staffCanEditTaxAndOperational}
                                                        title={
                                                            canAddMoreTaxTypes
                                                                ? "Add another tax type row"
                                                                : "Maximum number of tax type rows reached"
                                                        }
                                                        sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#2099d2', '&:hover': { backgroundColor: '#176990' } }}
                                                    >
                                                        Add More
                                                    </Button>
                                                ) : null}
                                            </Box>
                                            <Paper variant="outlined" sx={paperSectionSx}>
                                                <Box>
                                                    {(CustTaxAndFees ?? []).map((taxAndFee, index) => {
                                                        const rowKey = getTaxRowStableKey(taxAndFee, index);
                                                        return (
                                                        <React.Fragment key={rowKey}>
                                                            <Grid
                                                                container
                                                                spacing={2}
                                                                xs={12}
                                                                className={`d-flex ms-0 align-items-center ${index === (CustTaxAndFees.length - 1) ? 'mb-0' : 'mb-2 border-bottom pb-3'}`}
                                                            >
                                                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                    {staffCanEditTaxAndOperational ? (
                                                                        (() => {
                                                                            const isCurrentRowEmpty = isTaxRowEmpty(taxAndFee);
                                                                            const disableDelete = (CustTaxAndFees ?? []).length <= 1 && isCurrentRowEmpty;
                                                                            const disabledTitle = 'At least one tax type row is required';
                                                                            return (
                                                                        <IconButton
                                                                            type="button"
                                                                            color="error"
                                                                            disabled={disableDelete || !staffCanEditTaxAndOperational}
                                                                            title={disableDelete ? disabledTitle : 'Delete tax type'}
                                                                            sx={{ marginTop: 3 }}
                                                                            onClick={() => handleDeleteRow(index)}
                                                                        >
                                                                            <DeleteOutlineOutlinedIcon sx={{ color: '#dc3545' }} />
                                                                        </IconButton>
                                                                            );
                                                                        })()
                                                                    ) : null}
                                                                    <FormControl sx={{ width: '100%' }} >
                                                                        <FormHelperText className='formtexthelper-heading' >
                                                                            Tax Type
                                                                        </FormHelperText>
                                                                        <Select
                                                                            value={taxAndFee.taxName}
                                                                            id={`tax-type-select-${rowKey}`}
                                                                            label={null}
                                                                            onChange={(e) => handleTaxNameChange(e, index)}
                                                                            disabled={!staffCanEditTaxAndOperational}
                                                                            name="TaxAndFee"
                                                                            className="border-round"
                                                                            IconComponent={ExpandMoreIcon}
                                                                            displayEmpty
                                                                            sx={selectFieldSx}
                                                                        >
                                                                            {(getTaxTypeSelectOptionsForRow(index) ?? []).map((fee, key) => (
                                                                                <MenuItem key={key} value={fee}  >
                                                                                    {fee}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                                                    <FormHelperText className='formtexthelper-heading' >
                                                                        Tax Payee
                                                                    </FormHelperText>
                                                                    <FormControl sx={{ width: '100%' }} >
                                                                        <TextField
                                                                            name={`payee-${rowKey}`}
                                                                            id={`payee-${rowKey}`}
                                                                            value={taxAndFee.payee ?? ''}
                                                                            onChange={(e) => handleTaxPayeeChange(index, e.target.value)}
                                                                            sx={textFieldSx}
                                                                            disabled={!staffCanEditTaxAndOperational}
                                                                        />
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                                                    <FormHelperText className='formtexthelper-heading' >
                                                                        Amount
                                                                    </FormHelperText>
                                                                    <FormControl sx={{ width: '100%' }} >
                                                                        <NumericFormat
                                                                            customInput={TextField}
                                                                            value={normalizeTaxAmountForNumericFormat(taxAndFee.amount)}
                                                                            onValueChange={(values) => {
                                                                                handleTaxAmountChange(index, values.value);
                                                                            }}
                                                                            thousandSeparator=","
                                                                            decimalSeparator="."
                                                                            prefix="$"
                                                                            valueIsNumericString
                                                                            allowNegative
                                                                            name={`amount-${rowKey}`}
                                                                            id={`amount-${rowKey}`}
                                                                            fullWidth
                                                                            variant="outlined"
                                                                            label={null}
                                                                            disabled={!staffCanEditTaxAndOperational}
                                                                            sx={{...textFieldSx, '& .MuiInputBase-input' : { textAlign: 'right', padding: '3.5px 14px !important' } }}
                                                                        />
                                                                    </FormControl>
                                                                </Grid>
                                                            </Grid>

                                                        </React.Fragment>
                                                    );
                                                    })}
                                                </Box>
                                            </Paper>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Typography variant="overline" sx={sectionTitleSx}>Notes</Typography>
                                            <Paper variant="outlined" sx={paperSectionSx}>
                                                <Grid container spacing={2}>
                                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                        <FormControl sx={{ width: '100%' }} >
                                                            <FormHelperText className='formtexthelper-heading' >
                                                                Client Notes
                                                            </FormHelperText>
                                                            <FMTextField name="clientNotes"
                                                                InputLabelProps={{ shrink: true }}
                                                                label={null} type="Text"
                                                                disabled={policyReadOnlyFromCompleted}
                                                                fullWidth variant="outlined" sx={textFieldSx} />
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                        <FormControl sx={{ width: '100%' }} >
                                                            <FormHelperText className='formtexthelper-heading' >
                                                                Client div
                                                            </FormHelperText>
                                                            <FMTextField name="clientDiv" InputLabelProps={{ shrink: true }} label={null} type="Text" disabled={policyReadOnlyFromCompleted} fullWidth variant="outlined" sx={textFieldSx} />
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Typography variant="overline" sx={sectionTitleSx}>Status</Typography>
                                            <Paper variant="outlined" sx={paperSectionSx}>
                                                <Grid container spacing={2}>
                                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                        <FormControl sx={{ width: '100%' }} >
                                                            <FormHelperText className='formtexthelper-heading' >
                                                                Filer Notes
                                                            </FormHelperText>
                                                            <FMTextField name="filerNotes"
                                                                InputLabelProps={{ shrink: true }}
                                                                label={null} type="Text"
                                                                disabled={policyReadOnlyFromCompleted}
                                                                fullWidth variant="outlined" sx={textFieldSx} />
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                        <FormControl sx={{ width: '100%' }} >
                                                            <FormHelperText className='formtexthelper-heading' >
                                                                Filer Name
                                                            </FormHelperText>
                                                            <FMTextField name="filerName" InputLabelProps={{ shrink: true }} label={null} type="Text" disabled={policyReadOnlyFromCompleted} fullWidth variant="outlined" sx={textFieldSx} />
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                        <FormHelperText className='formtexthelper-heading' >Date Filed</FormHelperText>
                                                        <DatePicker
                                                            inputFormat="MM/DD/YYYY"
                                                            label={null}
                                                            disabled={policyReadOnlyFromCompleted}
                                                            // className="select-input-border text-input-box"
                                                            // value={DateFiled}
                                                            // onChange={(v) => dateFiledHandleChange(v ?? "")}
                                                            value={values.dateFiled ?? ""}
                                                            onChange={(v) =>
                                                                setFieldValue("dateFiled", v)
                                                            }
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    fullWidth
                                                                    size="small"
                                                                    {...params}
                                                                    name="dateFiled"
                                                                    sx={textFieldSx} />
                                                            )}
                                                        />
                                                    </Grid>
                                                    {/* {CustomerPolicyDetails.policySubStatus === 'Filed on Binder' ? */}
                                                    {/* {binderFiledDate !== '' && binderFiledDate !== undefined && binderFiledDate !== null  ? */}
                                                    {isValid(binderFiledDate)  ?
                                                        <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                            <FormHelperText className='formtexthelper-heading'>Filed with Binder Date</FormHelperText>
                                                            <DatePicker
                                                                inputFormat="MM/DD/YYYY"
                                                                label={null}
                                                                disabled={policyReadOnlyFromCompleted}
                                                                // className="select-input-border text-input-box"
                                                                value={values.filedBinderDate ? (typeof values.filedBinderDate === 'string' ? (/^\d{4}-\d{2}-\d{2}$/.test(values.filedBinderDate) ? dayjs(values.filedBinderDate, "YYYY-MM-DD") : /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(values.filedBinderDate) ? dayjs(values.filedBinderDate, "MM/DD/YYYY") : dayjs(values.filedBinderDate)) : dayjs(values.filedBinderDate)) : null}
                                                                onChange={(v) =>
                                                                    setFieldValue("filedBinderDate", v)
                                                                }
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        {...params}
                                                                        name={"filedBinderDate"}
                                                                        sx={textFieldSx} />
                                                                )}
                                                            />
                                                        </Grid>
                                                        : ""}
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                                <FormHelperText className='formtexthelper-heading' >First Request</FormHelperText>
                                                                <DatePicker
                                                                    inputFormat="MM/DD/YYYY"
                                                                    label={null}
                                                                    disabled={policyReadOnlyFromCompleted}
                                                                    // className="select-input-border text-input-box"
                                                                    shouldDisableDate={isDateGreaterThanToday}
                                                                    value={values.firstRequest ?? ""}
                                                                    onChange={(v) =>
                                                                        setFieldValue("firstRequest", v)
                                                                    }
                                                                    // value={FirstRequest}
                                                                    // onChange={(v) => firstRquestHandleChange(v ?? "")}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            fullWidth
                                                                            size="small"
                                                                            {...params}
                                                                            name="firstRequest"
                                                                            sx={textFieldSx} />
                                                                    )}
                                                                />
                                                            </Grid>

                                                            <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                                <FormHelperText className='formtexthelper-heading' >Second Request</FormHelperText>
                                                                <DatePicker
                                                                    inputFormat="MM/DD/YYYY"
                                                                    label={null}
                                                                    disabled={policyReadOnlyFromCompleted}
                                                                    // className="select-input-border text-input-box"
                                                                    shouldDisableDate={isDateGreaterThanToday}
                                                                    value={values.secondRequest ?? ""}
                                                                    onChange={(v) =>
                                                                        setFieldValue("secondRequest", v)
                                                                    }
                                                                    // value={SecondRequest}
                                                                    // onChange={(v) => secondRquestHandleChange(v ?? "")}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            fullWidth
                                                                            size="small"
                                                                            {...params}
                                                                            name="secondRequest"
                                                                            sx={textFieldSx} />
                                                                    )}
                                                                />
                                                            </Grid>

                                                            <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                                <FormHelperText className='formtexthelper-heading' >Third & Final Request</FormHelperText>
                                                                <DatePicker
                                                                    inputFormat="MM/DD/YYYY"
                                                                    label={null}
                                                                    disabled={policyReadOnlyFromCompleted}
                                                                    // className="select-input-border text-input-box"
                                                                    shouldDisableDate={isDateGreaterThanToday}
                                                                    value={values.thirdRequest ?? ""}
                                                                    onChange={(v) =>
                                                                        setFieldValue("thirdRequest", v)
                                                                    }
                                                                    // value={ThirdRequest}
                                                                    // onChange={(v) => thirdRquestHandleChange(v ?? "")}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            fullWidth
                                                                            size="small"
                                                                            {...params}
                                                                            name="thirdRequest"
                                                                            sx={textFieldSx} />
                                                                    )}
                                                                />
                                                            </Grid>
                                                            <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                                <FormHelperText className='formtexthelper-heading' >Suspended</FormHelperText>
                                                                <DatePicker
                                                                    inputFormat="MM/DD/YYYY"
                                                                    label={null}
                                                                    disabled={policyReadOnlyFromCompleted}
                                                                    // className="select-input-border text-input-box"
                                                                    shouldDisableDate={isDateGreaterThanToday}
                                                                    value={values.suspended ?? ""}
                                                                    onChange={(v) =>
                                                                        setFieldValue("suspended", v)
                                                                    }
                                                                    // value={Susupended}
                                                                    // onChange={(v) => suspendedHandleChange(v ?? "")}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            fullWidth
                                                                            size="small"
                                                                            {...params}
                                                                            name="suspended"
                                                                            sx={textFieldSx} />
                                                                    )}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Typography variant="overline" sx={sectionTitleSx}>Transaction Documents</Typography>
                                            
                                                {RequireedDocuments && RequireedDocuments.length > 0 ?
                                                    <>
                                                        {/* <div className="card-body">
                                                            <div className="document-container">
                                                                {
                                                                    RequireedDocuments?.map((file, key) => (
                                                                        <div key={key} className="document-item" style={{backgroundColor: "white"}}>
                                                                            {UploadedDocument.find((item) => item.documentTypeId == file.documentTypeId) ? 
                                                                                <ViewDocuments docTypeId={file.documentTypeId}/>
                                                                                :
                                                                                <GenericStyledDropZone
                                                                                    key={key} doc={file}
                                                                                    limitSize={CustomerPolicyDetails?.homeState === 'NY' ? 1 : 10}
                                                                                />
                                                                            }
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div> */}
                                                        <div className="card-body">
                                                            {loading && <LinearProgress sx={{ backgroundColor: "#132D3D" }} />}
                                                            <Box
                                                                sx={{
                                                                    height: '100%',
                                                                    width: '100%',
                                                                    borderRadius: '12px',
                                                                    overflow: 'hidden',
                                                                    // boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)',
                                                                    border: '1px solid #e2e8f0',
                                                                    backgroundColor: '#ffffff',
                                                                    position: 'relative',
                                                                }}
                                                            >
                                                                <DataGridPro
                                                                    key={`datagrid-${refreshKey}-${groupedRows.length}`}
                                                                    autoHeight
                                                                    rows={groupedRows.map((r, idx) => ({
                                                                        id: `${r.first.customerPolicyDocumentId}-${idx}`,
                                                                        fileName: r.fileName,
                                                                        docTypeNames: r.docTypeNames,
                                                                        uploadedAt: r.uploadedAt,
                                                                        uploadedBy: r.uploadedBy,
                                                                        sizeText: r.sizeText,
                                                                        pagesText: r.pagesText,
                                                                        first: r.first,
                                                                        allDocuments: r.allDocuments
                                                                    }))}
                                                                    columns={([
                                                                        { field: 'fileName', headerName: 'File Name', flex: 1, minWidth: 200, renderCell: (params) => (
                                                                            <Link href={params.row.first.blob_Address} target="_blank" sx={{ textDecoration: 'none', overflow: 'initial', textOverflow: 'ellipsis', whiteSpace: 'break-spaces',lineHeight:'normal' }}>{params.value || '-'}</Link>
                                                                        ) },
                                                                        { field: 'docTypeNames', headerName: 'Document Types', flex: 1, minWidth: 310, maxWidth: 400, renderCell: (params) => (
                                                                                <Box sx={{ width: '100%', overflow: 'initial', textOverflow: 'ellipsis', whiteSpace: 'break-spaces',lineHeight:'normal' }}>{params.value || '-'}</Box>
                                                                        ) },
                                                                        { field: 'uploadedAt', headerName: 'Upload Date', flex: 0.8, minWidth: 160 },
                                                                        { field: 'uploadedBy', headerName: 'Uploaded By', flex: 0.8, minWidth: 160 },
                                                                        { field: 'sizeText', headerName: 'File Size', flex: 0.6, minWidth: 120 },
                                                                        // { field: 'pagesText', headerName: 'Pages', flex: 0.4, minWidth: 100 },
                                                                        ( canDeleteDocuments() && !policyReadOnlyFromCompleted && {field: 'actions', 
                                                                            headerName: 'Actions', 
                                                                            sortable: false, 
                                                                            filterable: false, 
                                                                            flex: 0.5, 
                                                                            minWidth: 120, 
                                                                            renderCell: (params: any) => (
                                                                                <IconButton color="error" onClick={() => handleRemoveUploadedDoc(params.row)}>
                                                                                    <DeleteOutlineOutlinedIcon sx={{ fontSize: 20, color: "#d32f2f" }} />
                                                                                </IconButton>
                                                                            )})
                                                                    ]) as GridColDef[]}
                                                                    pagination
                                                                    rowsPerPageOptions={[5, 10, 25]}
                                                                    // pageSize={rowsPerPage}
                                                                    // onPageSizeChange={(newPageSize: number) => setRowsPerPage(newPageSize)}
                                                                    // onPageChange={(newPage: number) => setPage(newPage)}
                                                                    disableSelectionOnClick
                                                                    disableColumnMenu
                                                                    sx={{
                                                                        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                                                                        border: 'none',
                                                                        fontSize: '14px',
                                                                        color: '#475569',
                                                                        backgroundColor: '#ffffff',
                                                                        '& .MuiDataGridPro-columnHeaderTitle': {
                                                                            whiteSpace: 'normal',
                                                                            lineHeight: 1.35,
                                                                            fontWeight: 600,
                                                                            fontSize: '12px',
                                                                            letterSpacing: '0.05em',
                                                                            textTransform: 'uppercase',
                                                                            color: '#64748b',
                                                                        },
                                                                        '&.MuiDataGrid-root .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderTitleContainer': {
                                                                            pl: 1,
                                                                        },
                                                                        '& .MuiDataGrid-columnHeaders': {
                                                                            backgroundColor: '#f8fafc',
                                                                            borderBottom: '2px solid #e2e8f0',
                                                                            minHeight: '52px !important',
                                                                            maxHeight: '52px !important',
                                                                        },
                                                                        '& .MuiDataGrid-columnHeader': {
                                                                            '&:focus, &:focus-within': { outline: 'none' },
                                                                        },
                                                                        '& .MuiDataGrid-row': {
                                                                            transition: 'background-color 0.15s ease',
                                                                            '&:nth-of-type(even)': {
                                                                                backgroundColor: '#fafbfc',
                                                                            },
                                                                            '&:hover': {
                                                                                backgroundColor: '#f1f5f9 !important',
                                                                            },
                                                                        },
                                                                        '& .MuiDataGrid-cell': {
                                                                            borderBottom: '1px solid #f1f5f9',
                                                                            fontSize: '14px',
                                                                            color: '#334155',
                                                                            overflow: 'visible',
                                                                            whiteSpace: 'normal',
                                                                            lineHeight: 'normal',
                                                                            wordWrap: 'break-word',
                                                                            textOverflow: 'clip',
                                                                            '&:focus': { outline: 'none' },
                                                                        },
                                                                        '& .MuiDataGrid-virtualScroller': {
                                                                            border: 'none',
                                                                        },
                                                                        '& .MuiDataGrid-main': {
                                                                            border: 'none',
                                                                        },
                                                                        '& .MuiDataGrid-footerContainer': {
                                                                            borderTop: '1px solid #e2e8f0',
                                                                            backgroundColor: '#f8fafc',
                                                                            minHeight: 56,
                                                                        },
                                                                        '& .MuiTablePagination-root': {
                                                                            color: '#64748b',
                                                                            fontSize: '13px',
                                                                        },
                                                                        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                                                                            marginBottom: 0,
                                                                        },
                                                                        '& .MuiTablePagination-select': {
                                                                            fontSize: '13px',
                                                                            borderRadius: '6px',
                                                                            border: '1px solid #e2e8f0',
                                                                        },
                                                                        '& .MuiIconButton-root': {
                                                                            color: '#64748b',
                                                                            '&:hover': {
                                                                                backgroundColor: '#f1f5f9',
                                                                                color: '#475569',
                                                                            },
                                                                        },
                                                                    }}
                                                                />
                                                            </Box>
                                                        </div>
                                                        <Grid item xs={12} display="flex" justifyContent="flex-end" alignItems="center" mt={2}>
                                                            {AppFlags.enableFilingReviewUi && hasExtractionRecord && (
                                                                <Box display="flex" alignItems="center" ml="auto">
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        type="button"
                                                                        startIcon={<VisibilityOutlinedIcon />}
                                                                        sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#2099d2', '&:hover': { backgroundColor: '#176990' }, px: 2.5 }}
                                                                        onClick={() =>
                                                                            navigate(`${AppRoutes.filingQueue.batchReview}?CustomerPolicyId=${params.CustomerPolicyId}`)
                                                                        }
                                                                    >
                                                                        View Extraction Details
                                                                    </Button>
                                                                </Box>
                                                            )}
                                                            
                                                            {AppFlags && data?.isClient && !policyReadOnlyFromCompleted ? 
                                                                <Box display="flex" alignItems="center" ml="auto">
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        type="button"
                                                                        startIcon={<MailOutlineOutlinedIcon />}
                                                                        sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#2099d2', '&:hover': { backgroundColor: '#176990' }, px: 2.5 }}
                                                                        onClick={() =>
                                                                            handleSendMessage(Number(params.CustomerPolicyId), getPolicyStatus || "")
                                                                        }
                                                                        >
                                                                        Message
                                                                    </Button>
                                                                </Box>
                                                            : null}
                                                        </Grid>
                                                    </>
                                                    :
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12}>
                                                            <DialogTitle className="col-log-2">No mapping present for this transaction, you can upload supportive document here.</DialogTitle>
                                                        </Grid>
                                                    </Grid>
                                                }
                                            
                                        </Grid>

                                    <Grid item xs={12}>
                                        <Box sx={{ borderTop: 1, borderColor: 'divider', backgroundColor: 'grey.50', px: { xs: 2, sm: 3 }, py: 2, mt: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1.5, flexWrap: 'wrap' }}>
                                            <Box sx={{ display: 'flex', gap: 1.5 }}>
                                                {user?.userRoles.split(",").includes("Super Admin") ? (
                                                    <Button startIcon={<DeleteOutlineOutlinedIcon />} variant="outlined" color="error" size="medium" type="button" onClick={handlDeletePolicy} sx={{ textTransform: 'none', fontWeight: 600 }}>
                                                        Remove Policy
                                                    </Button>
                                                ) : null}
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                                {loading && <CircularProgress size={24} sx={{ mr: 1 }} />}
                                                {user?.userRoles.split(",").includes("Super Admin") ||
                                                    user?.userRoles.split(",").includes("MISC Filer") ||
                                                    user?.userRoles.split(",").includes("MISC State Reporter") ? (
                                                    <Button startIcon={<SaveOutlinedIcon />} variant="contained" size="medium" type="submit" disabled={isSubmitting || policyReadOnlyFromCompleted} sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#2099d2', '&:hover': { backgroundColor: '#176990' }, px: 2.5 }}>Save</Button>
                                                ) : (
                                                    <Button startIcon={<SaveOutlinedIcon />} variant="contained" size="medium" disabled sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#2099d2', px: 2.5 }}>Save</Button>
                                                )}
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    </Form>
                    )}
                </Formik>
                <ShowAllDocument open={showDoc} PolicyDocument={PolicyDocument} handleDocClose={handleDocClose} customerPolicyId={CustomerPolicyDetails.customerPolicyId}></ShowAllDocument>
            </React.Fragment>
        </LocalizationProvider >
    )
}